/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type MODERATION_MODE = "POST" | "PRE" | "%future added value";
export type STORY_MODE = "COMMENTS" | "QA" | "RATINGS_AND_REVIEWS" | "%future added value";
export type TAG = "ADMIN" | "EXPERT" | "FEATURED" | "MODERATOR" | "QUESTION" | "REVIEW" | "STAFF" | "UNANSWERED" | "%future added value";
export type CreateCommentMutation_story = {
    readonly id: string;
    readonly viewerRating: {
        readonly id: string;
        readonly tags: ReadonlyArray<{
            readonly code: TAG;
        }>;
        readonly rating: number | null;
    } | null;
    readonly settings: {
        readonly moderation: MODERATION_MODE;
        readonly mode: STORY_MODE;
        readonly live: {
            readonly enabled: boolean;
        };
        readonly experts: ReadonlyArray<{
            readonly id: string;
        }>;
    };
    readonly ratings: {
        readonly count: number;
        readonly average: number;
    } | null;
    readonly " $refType": "CreateCommentMutation_story";
};
export type CreateCommentMutation_story$data = CreateCommentMutation_story;
export type CreateCommentMutation_story$key = {
    readonly " $data"?: CreateCommentMutation_story$data;
    readonly " $fragmentRefs": FragmentRefs<"CreateCommentMutation_story">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any);
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "CreateCommentMutation_story",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "viewerRating",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Tag",
                        "kind": "LinkedField",
                        "name": "tags",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "code",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rating",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "StorySettings",
                "kind": "LinkedField",
                "name": "settings",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "moderation",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "mode",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "LiveConfiguration",
                        "kind": "LinkedField",
                        "name": "live",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "enabled",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "experts",
                        "plural": true,
                        "selections": [
                            (v0 /*: any*/)
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "StoryRatings",
                "kind": "LinkedField",
                "name": "ratings",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "count",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "average",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Story",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '66dd01a6008c3f6f22a28d9580cb6f2f';
export default node;
